var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDropdown32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6867 21.3539C16.3011 21.7167 15.6995 21.7161 15.3147 21.3525L6.76932 13.2786C6.35168 12.884 6.35168 12.2195 6.76932 11.8249L8.00885 10.6537C8.39638 10.2876 9.00299 10.2898 9.38778 10.6589L15.6539 16.6681C15.8474 16.8536 16.1526 16.8536 16.3461 16.6681L22.6069 10.6639C22.9939 10.2929 23.6046 10.2929 23.9914 10.6641L25.2405 11.8624C25.6535 12.2587 25.6503 12.9201 25.2334 13.3124L16.6867 21.3539Z",
    fill: "#E30031"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropdown32);
export default __webpack_public_path__ + "static/media/icon_dropdown_32.49ba0ebc849cd52848b728d004001c8e.svg";
export { ForwardRef as ReactComponent };